/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
import React from 'react';
import Button from 'elements/Button';

export default function BookConsultationThanks() {
  return (
      <section className="py-24">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold text-theme-blue mb-4">Thanks — we received your request</h1>
          <p className="text-gray-600 max-w-2xl mx-auto mb-6">
            we&rsquo;ll shortly to arrange a consultation and confirm the booking. If you don&rsquo;tfrom us within 48 hours, please check your spam folder or contact us directly.
          </p>

          <div className="flex items-center justify-center gap-4">
            <Button href="/" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full">Back to Home</Button>
            <Button href="/contact" type="link" className="px-6 py-3 border border-theme-purple rounded-full text-theme-purple">Discuss another project</Button>
          </div>
        </div>
      </section>
  );
}
